import React from 'react'

const CourseIcon = ({ color = '#999FAC' }) => {
  return (
    <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >

<path d="M4 8C3.71667 8 3.47933 7.90433 3.288 7.713C3.096 7.521 3 7.28333 3 7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6H14C14.2833 6 14.521 6.09567 14.713 6.287C14.9043 6.479 15 6.71667 15 7C15 7.28333 14.9043 7.521 14.713 7.713C14.521 7.90433 14.2833 8 14 8H4ZM4 12C3.71667 12 3.47933 11.904 3.288 11.712C3.096 11.5207 3 11.2833 3 11C3 10.7167 3.096 10.479 3.288 10.287C3.47933 10.0957 3.71667 10 4 10H14C14.2833 10 14.521 10.0957 14.713 10.287C14.9043 10.479 15 10.7167 15 11C15 11.2833 14.9043 11.5207 14.713 11.712C14.521 11.904 14.2833 12 14 12H4ZM4 16C3.71667 16 3.47933 15.904 3.288 15.712C3.096 15.5207 3 15.2833 3 15C3 14.7167 3.096 14.479 3.288 14.287C3.47933 14.0957 3.71667 14 4 14H10C10.2833 14 10.521 14.0957 10.713 14.287C10.9043 14.479 11 14.7167 11 15C11 15.2833 10.9043 15.5207 10.713 15.712C10.521 15.904 10.2833 16 10 16H4ZM15.65 18.3L13.5 16.15C13.3167 15.9667 13.225 15.7333 13.225 15.45C13.225 15.1667 13.3167 14.9333 13.5 14.75C13.6833 14.5667 13.9127 14.475 14.188 14.475C14.4627 14.475 14.7 14.5667 14.9 14.75L16.35 16.15L19.9 12.6C20.0833 12.4167 20.3123 12.325 20.587 12.325C20.8623 12.325 21.1 12.425 21.3 12.625C21.5 12.825 21.596 13.0667 21.588 13.35C21.5793 13.6333 21.475 13.875 21.275 14.075L17.05 18.3C16.8667 18.4833 16.6333 18.575 16.35 18.575C16.0667 18.575 15.8333 18.4833 15.65 18.3Z" 
 fill={color}/>

</svg>



  )
}

export default CourseIcon
